import { render } from "./LimitsContainer.vue?vue&type=template&id=3532f839"
import script from "./LimitsContainer.vue?vue&type=script&lang=js"
export * from "./LimitsContainer.vue?vue&type=script&lang=js"

import "./LimitsContainer.vue?vue&type=style&index=0&id=3532f839&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__